import BoxStyled from './Box.styled'
export interface IBoxProps {
  children: JSX.Element | ReadonlyArray<JSX.Element>
  fullOnSmallScreens?: boolean
}

const Box = (props: IBoxProps) => <BoxStyled {...props} />

export default Box
